var map = {
	"./company/company.module": [
		"./src/app/company/company.module.ts",
		"company-company-module~user-user-module",
		"common",
		"company-company-module"
	],
	"./customer/customer.module": [
		"./src/app/customer/customer.module.ts",
		"customer-customer-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./order/order.module": [
		"./src/app/order/order.module.ts",
		"common",
		"order-order-module"
	],
	"./tracking/tracking.module": [
		"./src/app/tracking/tracking.module.ts",
		"tracking-tracking-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"company-company-module~user-user-module",
		"common",
		"user-user-module"
	],
	"./vendor/vendor.module": [
		"./src/app/vendor/vendor.module.ts",
		"vendor-vendor-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;